import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function headerTitle(title) {
  return {
    type: constants.HEADER_TITLE,
    title
  };
}


/******************************
*******  Asynchronous  ********
******************************/

